import { BRAND_NAME } from "@/lib/brand";
import { styledTextString, type LandingTextValue } from "@/lib/landing/puck/styled-text";

export const DEFAULT_HERO_STATS = [
  { label: "Объём отчёта", value: "11+ страниц" },
  { label: "Критериев скоринга", value: "6" },
  { label: "Время генерации", value: "5–10 минут" },
  { label: "Источники", value: "РФ + Wordstat" },
] as const;

export type LandingHeroStat = { label: LandingTextValue; value: LandingTextValue };

export type LandingHeroMergedProps = {
  pill: LandingTextValue;
  title: LandingTextValue;
  subtitle: LandingTextValue;
  primaryLabel: LandingTextValue;
  primaryHref: string;
  secondaryLabel: LandingTextValue;
  secondaryHref: string;
  backgroundImageUrl: string;
  backgroundImageUrlDark: string;
  backgroundColor: string;
  layout: "standard" | "fullscreen";
  showStats: boolean;
  stats: LandingHeroStat[];
};

export const DEFAULT_HERO: LandingHeroMergedProps = {
  pill: `${BRAND_NAME} · desk research для рынка РФ`,
  title:
    "Получите исследование рынка и валидацию бизнес-идеи за минуты, а не недели",
  subtitle: `AI-отчёт 11+ страниц со scoring по 6 критериям, цифрами по рынку РФ и ссылками на источники. Не ChatGPT — методология ${BRAND_NAME}.`,
  primaryLabel: "Проверить идею",
  primaryHref: "/reports/create",
  secondaryLabel: "Как это работает",
  secondaryHref: "#how",
  backgroundImageUrl: "",
  backgroundImageUrlDark: "",
  backgroundColor: "",
  layout: "fullscreen",
  showStats: true,
  stats: [...DEFAULT_HERO_STATS],
};

export function mergeHeroProps(
  props: Partial<{
    pill: LandingTextValue;
    title: LandingTextValue;
    subtitle: LandingTextValue;
    primaryLabel: LandingTextValue;
    primaryHref: string;
    secondaryLabel: LandingTextValue;
    secondaryHref: string;
    backgroundImageUrl: string;
    backgroundImageUrlDark: string;
    backgroundColor: string;
    layout: "standard" | "fullscreen";
    showStats: boolean;
    stats: LandingHeroStat[];
  }> & { primaryHref?: string },
): LandingHeroMergedProps {
  const stats =
    Array.isArray(props.stats) && props.stats.length > 0
      ? props.stats
      : DEFAULT_HERO.stats;
  return {
    ...DEFAULT_HERO,
    ...props,
    pill: styledTextString(props.pill) ? props.pill! : DEFAULT_HERO.pill,
    title: styledTextString(props.title) ? props.title! : DEFAULT_HERO.title,
    subtitle: styledTextString(props.subtitle)
      ? props.subtitle!
      : DEFAULT_HERO.subtitle,
    primaryLabel: styledTextString(props.primaryLabel)
      ? props.primaryLabel!
      : DEFAULT_HERO.primaryLabel,
    secondaryLabel:
      props.secondaryLabel === undefined
        ? DEFAULT_HERO.secondaryLabel
        : props.secondaryLabel,
    layout:
      props.layout === "standard" || props.layout === "fullscreen"
        ? props.layout
        : DEFAULT_HERO.layout,
    stats,
    showStats: props.showStats !== false,
  };
}
